module.exports = __webpack_public_path__ + "static/media/emailIcon.88277c86.svg";